import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 회사 상세 조회
export const getCompaniesDetail = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 정보 수정
export const modifyCompaniesDetail = (companyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${companyIdx}`, body)
      .then((res) => {
        toast.success('회사정보가 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 부가정보 목록 조회
export const getAdditionalInfos = (type) => {
  return new Promise((resolve, reject) => {
    http
      .get("/additionalInfos", {
        params: { type },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 부가정보 목록 등록
export const createAdditionalInfos = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/additionalInfos", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 부가정보 조회
export const getAdditionalInfosDetail = (infoIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/additionalInfos/${infoIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 부가정보 수정
export const modifyAdditionalInfosDetail = (infoIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/additionalInfos/${infoIdx}`, body)
      .then((res) => {
        toast.success('부가정보가 수정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 부가정보 삭제
export const deleteAdditionalInfosDetail = (infoIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/additionalInfos/${infoIdx}`)
      .then((res) => {
        toast.success('부가정보가 삭제되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
